/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ blurb: NonNullable<unknown>, rate: NonNullable<unknown> }} Seo_Endpoint_DescriptionInputs */

const en_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Costs ${i?.rate}, paid per request in USD with no subscription. Start free.`)
};

const zh_hans1_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb}价格为${i?.rate}，按请求以美元付费，无需订阅。可免费开始。`)
};

const pt_br2_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Custa ${i?.rate}, pago por requisição em dólares, sem assinatura. Comece grátis.`)
};

const es_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Cuesta ${i?.rate}, se paga por solicitud en USD y sin suscripción. Empieza gratis.`)
};

const fr_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Coûte ${i?.rate}, payé par requête en USD sans abonnement. Commencez gratuitement.`)
};

const de_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Kostet ${i?.rate}, bezahlt pro Anfrage in USD, ohne Abo. Kostenlos starten.`)
};

const ru_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Стоит ${i?.rate}, оплата за запрос в долларах США, без подписки. Начните бесплатно.`)
};

const it_seo_endpoint_description = /** @type {(inputs: Seo_Endpoint_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.blurb} Costa ${i?.rate}, pagato a richiesta in USD senza abbonamento. Inizia gratis.`)
};

/**
* | output |
* | --- |
* | "{blurb} Costs {rate}, paid per request in USD with no subscription. Start free." |
*
* @param {Seo_Endpoint_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_description = /** @type {((inputs: Seo_Endpoint_DescriptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_DescriptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_description(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_description(inputs)
	if (locale === "es") return es_seo_endpoint_description(inputs)
	if (locale === "fr") return fr_seo_endpoint_description(inputs)
	if (locale === "de") return de_seo_endpoint_description(inputs)
	if (locale === "ru") return ru_seo_endpoint_description(inputs)
	if (locale === "it") return it_seo_endpoint_description(inputs)
	return en_seo_endpoint_description(inputs)
});